/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const sanitizeDetailSchema = z.object({
  id: z.number(),
  slug: z.string(),
  status: z.enum(['sanitized', 'skipped', 'disabled', 'skipped_published']),
  invalidFields: z.array(z.string()).optional(),
  disableReason: z.string().optional(),
  audioRelinked: z.boolean().optional(),
});

export const sanitizeResultSchema = z.object({
  sanitized: z.number(),
  skipped: z.number(),
  disabled: z.number(),
  relinked: z.number().optional(),
  total: z.number(),
  remaining: z.number(),
  lastId: z.number().optional(),
  details: z.array(sanitizeDetailSchema),
});

export type ISanitizeResult = z.infer<typeof sanitizeResultSchema>;

export const sanitizeChallengesResponseSchema = createApiResponseSchema(
  sanitizeResultSchema,
) as z.ZodSchema<IAPI<ISanitizeResult>>;

export type ISanitizeChallengesResponse = IAPI<ISanitizeResult>;
